export default "<div class=\"overflow-auto contenutoTextPopup\" [innerHTML]=\"html\"></div>\r\n"